define [], () ->
  name: 'home'
  public: true
  template: require('./home.jade')
  children: [
    name: 'landing', url: '^/',
    template:   require("./landing.jade")
    controller: require("./../home/login/login.coffee")
    params:
      view_app: null
  ,
    name: 'password_reset', url: '^/accounts/password_reset/',
    template: require("./../home/password_reset/password_reset.jade")
    controller: require("./../home/password_reset/password_reset.coffee")
  ,
    name: 'password_reset_confirm', url: '^/accounts/reset/{uidb64}/{token}/',
    template: require("./../home/password_reset_confirm/password_reset_confirm.jade")
    controller: require("./../home/password_reset_confirm/password_reset_confirm.coffee")
  ,
    name: 'password_reset_done', url: '^/accounts/reset/done/',
    template: require("./../home/password_reset_done/password_reset_done.jade")
    controller: require("./../home/password_reset_done/password_reset_done.coffee")
  ,
    name: '403', template: require("../home/403/403.jade")
  ,
    name: '404', 
    template: require("../home/404/404.jade")
    controller: require("./../home/404/404.coffee")
  ,
    name: '500', template: require("../home/500/500.jade")
  ]



// WEBPACK FOOTER //
// ./components/bare_home/routes.coffee